import { Vue, Component } from 'vue-property-decorator';
import { readUserProfile } from '@/store/main/getters';
import { IUserProfile } from '@/interfaces';
import { store } from '@/store';
import { readHasAdminAccess } from '@/store/main/getters';
import { mixin } from 'vue/types/umd';

@Component
export default class PrivilegeMixin extends Vue {
  // This call checks the privileges against the user record roles
  public roleCheck(prKey: string, privRequired: string) {
    const rec: IUserProfile | null = readUserProfile(this.$store);
    // console.log('roleCheck', prKey, privRequired);
    return true;
    // if (rec && rec.roles && rec.roles[prKey]) {
    //   const privUser = rec.roles[prKey];
    //   if (privRequired === 'Manage') {
    //     return privUser === 'Manage';
    //   } else if (privRequired === 'Write') {
    //     return privUser === 'Write' || privUser === 'Manage';
    //   } else if (privRequired === 'Read') {
    //     return (
    //       privUser === 'Read' || privUser === 'Write' || privUser === 'Manage'
    //     );
    //   }
    // } else {
    //   if (rec && rec.roles) {
    //     return false;
    //   } else {
    //     // No roles
    //     return true;
    //   }
    // }
  }

  public roleCheckNavBar(accessPath: string): boolean {

    const rec: IUserProfile | null = readUserProfile(this.$store);
    // console.log('roleCheckNavBar', accessPath);
    if (rec) {
      if (rec.is_superuser) {
        if (rec.rolemap && !rec.rolemap[accessPath]) {
          console.log('roleCheckNavBar undefined!', accessPath, rec.rolemap[accessPath]);
        }
        return true;
      }
      if (rec.rolemap) {
        // console.log('roleCheckNavBar', accessPath, rec.rolemap[accessPath]);
        if (rec.rolemap[accessPath] == null) {
          return false;
        } else {
          const access: string = rec.rolemap[accessPath]['*'];
          if (access === 'w') {
            return true;
          }
          // console.log('roleCheckNavBar', accessPath, access, rec.rolemap[accessPath]);
          return false;
        }
      }
    }
    return false;
  }

  public getUser(): IUserProfile | null {

    const rec: IUserProfile | null = readUserProfile(this.$store);
    // console.log('getRole', accessPath);
    return rec;
  }

  public roleCheckAPI(accessPath: string, apiName: string): boolean {

    const rec: IUserProfile | null = readUserProfile(this.$store);
    if (rec) {
      // console.log('roleCheckAPI', accessPath, apiName, rec, rec.is_superuser);
      if (rec.is_superuser) {
        return true;
      }
      if (rec.rolemap) {
        // console.log('roleCheckAPI', accessPath, apiName, rec.rolemap[accessPath]);
        if (rec.rolemap[accessPath] == null || rec.rolemap[accessPath].api == null) {
          return false;
        } else {
          const endpoints: string[] = rec.rolemap[accessPath].api;
          if (endpoints.includes(apiName)) {
            return true;
          }
          // console.log('roleCheckAPI', accessPath, apiName, endpoints, rec.rolemap[accessPath]);
          return false;
        }
      }
    }
    return false;
  }

  public roleCheckIsA(roles: string): boolean {
    const rec: IUserProfile | null = readUserProfile(this.$store);
    if (rec) {
      // console.log('roleCheckIsA', rec.userrole_name, roles, roles.split('|').includes(rec.userrole_name));
      if (rec.userrole_name !== 'super') {
        return roles.split('|').includes(rec.userrole_name);
      }
    }
    return true;
  }

  public isSuperUser() {
    return readHasAdminAccess(store);
  }
}
